<template>
  <div class="page-user">
    <crm-panel :title="'用户列表'">
      <div class="page-buttons">
        <crm-button
          v-if="auth.userImport && auth.userImport.toggleStatus"
          :buttonType="'secondary'"
          :text="'导入'"
          :disabled="isImportDisabled"
          @click="handleImport"
        >
        </crm-button>
        <crm-button
          v-if="auth.userAdd && auth.userAdd.toggleStatus"
          :buttonType="'secondary'"
          :text="'新增'"
          @click="isAddDialogVisible = true"
        >
        </crm-button>
      </div>
      <div class="mt20">
        <el-form ref="form" :inline="true">
          <el-form-item label="">
            <el-input
              placeholder="根据名称查询"
              v-model="searchName"
              class="input-with-select"
            >
              <el-select v-model="searchNameType" slot="prepend">
                <el-option label="用户名称" :value="1"></el-option>
                <el-option label="成员账号" :value="2"></el-option>
              </el-select>
              <i
                slot="suffix"
                class="el-input__icon el-icon-search"
                @click="handleSearch"
                style="cursor: pointer"
              ></i>
            </el-input>
          </el-form-item>
        </el-form>
      </div>
      <el-table
        :data="crmUsers.results"
        border
        v-loading="loading"
        height="100%"
        style="width: 100%"
      >
        <el-table-column prop="loginId" align="center" label="账号">
        </el-table-column>
        <el-table-column prop="userName" align="center" label="用户">
        </el-table-column>
        <el-table-column align="center" label="创建时间">
          <template slot-scope="scope">
            {{ scope.row.gmtCreated | formatTimeShow }}
          </template>
        </el-table-column>
        <el-table-column prop="teamName" align="center" label="是否管理员">
          <template slot-scope="scope">
            {{ scope.row.role === 'member' ? '否' : '是' }}
          </template>
        </el-table-column>
        <el-table-column
          v-if="auth.userDelete && auth.userDelete.toggleStatus"
          align="center"
          label="操作"
        >
          <template slot-scope="scope">
            <el-button @click="handleDelete(scope)" type="text" size="small"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="pageination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handlePageChange"
          :current-page="crmUsers.pageNumber"
          :page-sizes="[10, 30, 50]"
          :page-size="crmUsers.pageSize"
          layout="sizes, prev, pager, next"
          :total="crmUsers.totalCount"
        >
        </el-pagination>
      </div>
    </crm-panel>

    <!-- 新增用户弹窗 -->
    <el-dialog
      title="新增用户"
      :visible.sync="isAddDialogVisible"
      :width="'500px'"
      @close="cancelDialogVisible"
    >
      <el-form ref="addForm" :rules="rules" :model="addForm">
        <el-form-item label="账号：" label-width="100px" prop="loginId">
          <el-input
            v-model="addForm.loginId"
            placeholder="请输入账号"
            @blur="handleBlur(addForm.loginId)"
          >
          </el-input>
        </el-form-item>
        <el-form-item
          label="姓名："
          label-width="100px"
          prop="userName"
          v-if="addFormSearchEnd"
        >
          <el-input
            v-model="addForm.userName"
            placeholder="请输入用户姓名"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <crm-button
          :buttonType="'plain'"
          :text="'取消'"
          @click="cancelDialogVisible"
        >
        </crm-button>
        <crm-button :text="'确定'" @click="handleAddUser"></crm-button>
      </div>
    </el-dialog>
    <!-- 导入 -->
    <crm-upload
      :visible="isShowUplaod"
      :upload="upload"
      :handleClose="handleCloseUpload"
      download="https://kano.guahao.cn/0V9344835064"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { formatTimeShow } from '@/scripts/utils';
import crmPanel from '@/components/base/crmPanel';
import crmButton from '@/components/base/crmButton';
import crmUpload from '@/components/base/crmUpload';
import service from '~api/backstage';
import _ from 'lodash';

export default {
  components: {
    crmPanel,
    crmButton,
    crmUpload,
  },
  filters: {
    formatTimeShow,
  },
  data() {
    return {
      searchNameType: 1,
      searchName: '',
      loading: false,
      userAccount: '',
      userName: '',
      pageSize: 10,
      pageNumber: 1,
      isAddDialogVisible: false,
      addForm: {
        loginId: '',
        userName: '',
      },
      // 导入
      isImportDisabled: false,
      isShowUplaod: false,
      rules: {
        loginId: [
          {
            required: true,
            message: '请输入账号',
            trigger: 'blur',
          },
        ],
        userName: [
          {
            required: true,
            message: '请输入用户姓名',
            trigger: 'blur',
          },
        ],
      },
      searchLoading: false,
      addFormSearchEnd: false,
    };
  },
  computed: {
    ...mapGetters({
      crmUsers: 'backstage/crmUsers',
      auth: 'authority/auth',
      backstageMenu: 'authority/backstageMenu',
    }),
  },
  created() {
    this.handleQueryList();
  },
  methods: {
    ...mapActions({
      getUserList: 'backstage/getUserList',
      addUser: 'backstage/addUser',
      deleteUser: 'backstage/deleteUser',
      upload: 'backstage/upload',
    }),
    handleSearch() {
      this.userName = null;
      this.userAccount = null;
      if (this.searchName) {
        if (this.searchNameType === 1) {
          this.userName = this.searchName;
        } else if (this.searchNameType === 2) {
          this.userAccount = this.searchName;
        }
      }
      this.pageNumber = 1;
      this.handleQueryList();
    },
    handleQueryList() {
      this.loading = true;
      this.getUserList({
        pageSize: this.pageSize,
        pageNumber: this.pageNumber,
        userName: this.userName,
        loginId: this.userAccount,
      }).finally(() => {
        this.loading = false;
      });
    },
    handleDelete(scope) {
      this.$confirm(`确定删除${scope.row.userName}？`)
        .then(() => {
          this.deleteUser({
            uid: scope.row.uid,
          }).then(() => {
            this.$message({
              type: 'success',
              message: '删除成功',
            });
            this.handleQueryList();
          });
        })
        .catch(() => {});
    },
    handleSizeChange(size) {
      this.pageSize = size;
      this.pageNumber = 1;
      this.handleQueryList();
    },
    handlePageChange(page) {
      this.pageNumber = page;
      this.handleQueryList();
    },
    handleAddUser() {
      if (!this.addFormSearchEnd) return;
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.addUser({
            loginId: this.addForm.loginId || '',
            userName: this.addForm.userName || '',
          }).then(() => {
            this.$message({
              type: 'success',
              message: '添加成功',
            });
            this.handleQueryList();
            this.isAddDialogVisible = false;
            this.cancelDialogVisible();
          });
        }
      });
    },
    // 导入
    handleImport() {
      this.isImportDisabled = true;
      this.isShowUplaod = true;
    },
    handleCloseUpload() {
      this.isImportDisabled = false;
      this.isShowUplaod = false;
      this.handleSearch();
    },
    // eslint-disable-next-line
    handleBlur(query) {
      if (!query) return;
      this.searchLoading = true;
      service
        .apiSearchUserInfo({ loginId: query })
        .then((res) => {
          this.addForm.loginId = res.data.loginId || '';
          this.addForm.userName = res.data.userName || '';
          this.addFormSearchEnd = true;
        })
        .finally(() => {
          this.searchLoading = false;
          // 如果已经关闭或者取消了 重置
          if (!this.isAddDialogVisible) {
            this.cancelDialogVisible();
          }
        });
    },
    cancelDialogVisible() {
      this.isAddDialogVisible = false;
      this.$refs.addForm.resetFields();
      this.addForm.loginId = '';
      this.addForm.userName = '';
      this.addFormSearchEnd = false;
    },
  },
};
</script>

<style lang="less">
@import '~@/styles/var.less';

.page-user {
  display: flex;
  flex: 1;
  width: 100%;
}
</style>
